exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal.fade {\n  z-index: 10000000 !important;\n}\n\n.modal-xl .modal-body\n{\n    /* width: 300px; */\n    height: 160px; /* control height here */\n}\n", ""]);

